import { render, staticRenderFns } from "./CandidateClosingFields.vue?vue&type=template&id=57735384&"
import script from "./CandidateClosingFields.vue?vue&type=script&lang=js&"
export * from "./CandidateClosingFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports